import * as React from "react";
import { Table, TableDataRowProps } from "../../../../Common/UI/Index";
import { PopulateCustomTable } from "./ColumnDefinitions";

interface IScheduleTableView {
  scheduleList: TableDataRowProps[];
  onRowSelected: (e: React.MouseEvent<any>) => void;
}

export const ScheduleTableView: React.FC<IScheduleTableView> = (props: IScheduleTableView) => {
  const { scheduleList, onRowSelected } = props;

  return (
    <div>
      <Table
        id="scheduleTableId"
        tableData={PopulateCustomTable(scheduleList)}
        emptyStateText="No entries found"
        onRowSelected={onRowSelected}
      />
    </div>
  );
};
